// extracted by mini-css-extract-plugin
export default {"root":"river-logo-account_root__7WQXk","image":"river-logo-account_image__zZxia"};